/* Same-day order fee. When the order's pickup or delivery date (cart attributes saved by assets/adelaide-fulfilment.js)
   is today in store time, keep exactly one fee line in the cart; otherwise, or when no cakes are left, remove it.
   Configured in Theme settings → Cart (window.adelaideSameDayFee is printed by layout/theme.liquid). */
(() => {
  const config = window.adelaideSameDayFee;
  if (!config || !config.variantId) return;

  const todayIso = () => {
    const parts = {};
    try {
      new Intl.DateTimeFormat('en-AU', { timeZone: config.timezone || 'Australia/Adelaide', year: 'numeric', month: '2-digit', day: '2-digit' })
        .formatToParts(new Date()).forEach((part) => { parts[part.type] = part.value; });
      return `${parts.year}-${parts.month}-${parts.day}`;
    } catch (error) {
      return new Date().toISOString().slice(0, 10);
    }
  };

  const chosenDate = (attributes) => {
    const method = String(attributes.Fulfilment || '');
    const value = method === 'Delivery' ? attributes['Delivery date'] : method === 'Pickup' ? attributes['Pickup date'] : '';
    return String(value || '').slice(0, 10);
  };

  const post = (url, body) => fetch(url, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
    body: JSON.stringify(body),
  });

  let running = null;
  let again = false;

  const sync = async () => {
    if (running) { again = true; return running; }
    running = (async () => {
      const root = window.routes?.cart_url || '/cart';
      const cart = await fetch(`${root}.js`, { headers: { Accept: 'application/json' } }).then((r) => r.json());
      const feeId = Number(config.variantId);
      const feeLines = cart.items.filter((item) => item.variant_id === feeId);
      const cakes = cart.items.filter((item) => item.variant_id !== feeId);
      const needFee = cakes.length > 0 && chosenDate(cart.attributes || {}) === todayIso();
      let changed = false;
      if (needFee && !feeLines.length) {
        await post(`${window.routes?.cart_add_url || '/cart/add'}.js`, { items: [{ id: feeId, quantity: 1 }] });
        changed = true;
      } else if (needFee && (feeLines.length > 1 || feeLines[0].quantity !== 1)) {
        const updates = {};
        feeLines.forEach((line, index) => { updates[line.key] = index === 0 ? 1 : 0; });
        await post(`${window.routes?.cart_update_url || '/cart/update'}.js`, { updates });
        changed = true;
      } else if (!needFee && feeLines.length) {
        const updates = {};
        feeLines.forEach((line) => { updates[line.key] = 0; });
        await post(`${window.routes?.cart_update_url || '/cart/update'}.js`, { updates });
        changed = true;
      }
      if (changed) refresh();
    })().catch(() => {}).finally(() => {
      running = null;
      if (again) { again = false; sync(); }
    });
    return running;
  };

  // Re-draw the cart page, drawer and cart count after the fee line changed.
  const refresh = () => {
    if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      publish(PUB_SUB_EVENTS.cartUpdate, { source: 'adelaide-same-day-fee' });
    } else {
      document.querySelectorAll('cart-items, cart-drawer-items').forEach((items) => items.onCartUpdate?.());
    }
    fetch(`${window.Shopify?.routes?.root || '/'}?sections=cart-icon-bubble`)
      .then((response) => response.json())
      .then((sections) => {
        const bubble = document.getElementById('cart-icon-bubble');
        const html = sections['cart-icon-bubble'];
        if (!bubble || !html) return;
        const fresh = new DOMParser().parseFromString(html, 'text/html').querySelector('.shopify-section');
        if (fresh) bubble.innerHTML = fresh.innerHTML;
      })
      .catch(() => {});
  };

  let timer;
  const queue = (delay = 300) => { clearTimeout(timer); timer = setTimeout(sync, delay); };

  window.adelaideSameDayFee.sync = queue;
  document.addEventListener('adelaide:fulfilment-saved', () => queue(400));
  const listen = () => {
    if (typeof subscribe !== 'function' || typeof PUB_SUB_EVENTS === 'undefined') return;
    subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => { if (event?.source !== 'adelaide-same-day-fee') queue(); });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => { listen(); if (config.hasItems) queue(0); });
  else { listen(); if (config.hasItems) queue(0); }
})();
